module.exports = __webpack_public_path__ + "img/nose_male_narrow.0860bbcb.png";